module.exports = __webpack_public_path__ + "static/media/ad-lmi-claims.5cef367c.jpg";